// JWT decoding utility to extract user information
export function decodeJWT(token: string): any {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
}

// Get user role from localStorage (set by LMS after first access)
export function getUserRoleFromToken(): 'admin' | 'learner' | null {
  // Check if LMS role is stored in localStorage
  const storedRole = localStorage.getItem('lms_user_role');
  
  console.log('🔍 getUserRoleFromToken - LMS Role from localStorage:', storedRole);
  
  if (storedRole === 'admin' || storedRole === 'learner') {
    return storedRole;
  }
  
  return null;
}

// Fetch and cache user's LMS role from Learn_BE
export async function fetchAndCacheLMSRole(): Promise<'admin' | 'learner' | null> {
  try {
    const token = localStorage.getItem('access_token') || 
                  localStorage.getItem('authToken') || 
                  localStorage.getItem('token');
    
    if (!token) {
      console.warn('⚠️ No auth token found');
      return null;
    }

    // Call Learn_BE to get user role
    const response = await fetch('https://d3puzfmtaz5ksu.cloudfront.net/api/learn/v1/lms/me', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      console.warn('⚠️ Failed to fetch LMS role:', response.status);
      return null;
    }

    const data = await response.json();
    const role = data.role as 'admin' | 'learner';
    
    // Cache the role in localStorage
    if (role) {
      localStorage.setItem('lms_user_role', role);
      console.log('✅ LMS role cached:', role);
    }
    
    return role;
  } catch (error) {
    console.error('❌ Error fetching LMS role:', error);
    return null;
  }
}

